module.exports = __webpack_public_path__ + "img/toubanner.405b48a.png";